import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=5522144c&scoped=true&"
import script from "./MediaViewer.vue?vue&type=script&lang=js&"
export * from "./MediaViewer.vue?vue&type=script&lang=js&"
import style0 from "./MediaViewer.vue?vue&type=style&index=0&id=5522144c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522144c",
  null
  
)

export default component.exports